module.exports = __webpack_public_path__ + "img/tarj1-2.5530d7f7.svg";